import type { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type LocationQuery, type RouteParamsGeneric, useRoute } from 'vue-router';

export interface LanguageSwitchLinkResult {
  name: string;
  query: LocationQuery;
  params: RouteParamsGeneric;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useLanguageSwitchLink() {
  const route = useRoute();

  const getLanguageSwitchLink = (language: HgSupportedLanguage): LanguageSwitchLinkResult => {
    if (typeof route.meta?.getLanguageSwitchLink === 'function') {
      return route.meta?.getLanguageSwitchLink(route, language);
    }

    return {
      name: (route.name as string)?.replace(/-\w+$/, `-${language}`),
      query: route.query,
      params: { ...route.params, locale: language },
    };
  };

  return {
    getLanguageSwitchLink,
  };
}
